/**
 * Internal-testing override for "cancel after my next delivery": landing on the
 * portal with ?so_cancel_after_delivery=1 (or =true) shows the option regardless
 * of the runtime switch, so the team can test in production. Sticks in
 * sessionStorage for the rest of the tab session (same as ?so_cancel_chat).
 */

const OVERRIDE_STORAGE_KEY = "so_cancel_after_delivery_override";

export function parseCancelAfterDeliveryOverrideParam(search: string): boolean {
  const value = new URLSearchParams(search).get("so_cancel_after_delivery");
  return value === "1" || value === "true";
}

export function hasCancelAfterDeliveryOverride(): boolean {
  if (typeof window === "undefined") return false;
  try {
    if (parseCancelAfterDeliveryOverrideParam(window.location.search)) {
      sessionStorage.setItem(OVERRIDE_STORAGE_KEY, "1");
      return true;
    }
    return sessionStorage.getItem(OVERRIDE_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}
